import type { FC } from 'react';

import type { UserChatMessage } from '../types';
import { userMessageBubbleCss, userMessageCss } from './UserMessage.styles';

interface UserMessageProps {
  message: UserChatMessage;
}

/** Renders a user-submitted message bubble aligned to the right of the conversation. */
export const UserMessage: FC<UserMessageProps> = ({ message }) => (
  <div className={userMessageCss}>
    <div className={userMessageBubbleCss}>{message.content}</div>
  </div>
);

UserMessage.displayName = 'UserMessage';
